import * as t from "io-ts";

export const GeoCoordValidator = t.intersection([
  t.type({
    latCoord: t.number,
    longCoord: t.number,
  }),
  t.partial({
    speed: t.number,
    bearing: t.number,
    dttm: t.number,
    deviceId: t.string,
  }),
]);

export interface GeoCoord {
  latCoord: number;
  longCoord: number;
  speed?: number
  bearing?: number
  dttm?: number;
  deviceId?: string;
}
